// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_fR"};